import React from 'react';
import { Section } from './ui/Section';
export function TransformationSection() {
  return <>
      <Section background="white" data-id="element-361">
        <div className="text-center mb-8" data-id="element-362">
          <h2 className="text-2xl md:text-3xl font-bold text-[#1e3a5f] mb-6 leading-snug" data-id="element-363">
            Así se siente cuando recuperas el control en casa:
          </h2>

          <div className="space-y-2 mb-8 text-left max-w-xl mx-auto" data-id="element-364">
            <div className="flex items-center gap-3 py-2.5 px-3 border-b border-gray-100" data-id="element-365">
              <span className="text-lg" data-id="element-366">🍽️</span>
              <span className="text-[#2d3748] text-sm" data-id="element-367">
                La cena vuelve a ser conversación, risas y miradas — no silencio
                y pantallas.
              </span>
            </div>
            <div className="flex items-center gap-3 py-2.5 px-3 border-b border-gray-100" data-id="element-368">
              <span className="text-lg" data-id="element-369">😴</span>
              <span className="text-[#2d3748] text-sm" data-id="element-370">
                No más discusiones antes de dormir por "5 minutos más".
              </span>
            </div>
            <div className="flex items-center gap-3 py-2.5 px-3 border-b border-gray-100" data-id="element-371">
              <span className="text-lg" data-id="element-372">🤝</span>
              <span className="text-[#1e3a5f] text-sm font-medium" data-id="element-373">
                Tu hijo te escucha cuando le hablas… sin tener que repetirlo
                tres veces.
              </span>
            </div>
            <div className="flex items-center gap-3 py-2.5 px-3 border-b border-gray-100" data-id="element-374">
              <span className="text-lg" data-id="element-375">💪</span>
              <span className="text-[#2d3748] text-sm" data-id="element-376">
                Vuelves a poner límites sin culpa y sin perder la calma.
              </span>
            </div>
            <div className="flex items-center gap-3 py-2.5 px-3" data-id="element-377">
              <span className="text-lg" data-id="element-378">🏠</span>
              <span className="text-[#2d3748] text-sm" data-id="element-379">
                Sientes que vuelves a liderar tu hogar con seguridad.
              </span>
            </div>
          </div>

          <div className="text-center max-w-xl mx-auto mb-8" data-id="element-380">
            <p className="text-[#1e3a5f] text-base md:text-lg font-semibold" data-id="element-381">
              Y eso no ocurre por casualidad.
            </p>
            <p className="text-[#1e3a5f] text-lg md:text-xl font-bold mt-1" data-id="element-382">
              Ocurre cuando tienes una estrategia clara.
            </p>
          </div>

          <div className="bg-[#1e3a5f] text-white p-6 rounded-2xl" data-id="element-383">
            <p className="text-sm uppercase tracking-widest text-blue-200 mb-2 font-semibold" data-id="element-384">
              Presentamos
            </p>
            <h3 className="text-2xl md:text-3xl font-extrabold mb-3" data-id="element-385">
              "PANTALLAS BAJO CONTROL"
            </h3>
            <p className="text-blue-100 text-sm md:text-base leading-relaxed" data-id="element-386">
              El método paso a paso diseñado para padres modernos que quieren
              retomar las riendas de su hogar con amor y firmeza.
            </p>
          </div>
        </div>
      </Section>

      <div className="bg-white pb-10 px-4" data-id="element-387">
        <img src="https://cdn.magicpatterns.com/uploads/kmpyfjAbrX2NFA18gFjysA/Nueva_Portada_de_libro_Pantallas_bajo_Control.png" alt="Pantallas Bajo Control - Guía para Padres Modernos" className="mx-auto w-full max-w-3xl rounded-2xl shadow-2xl" data-id="element-388" />
      </div>
    </>;
}